<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加</Button>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="title" label="标题" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="content" label="内容" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="xm" label="姓名" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <Avatar :src="'/api/upload/online/'+scope.row.img"/>
            &nbsp;
            {{scope.row.xm}}
          </template>
        </el-table-column>
        <el-table-column prop="gs" label="公司" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="zw" label="职位" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="show" label="预览量" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="num_comment" label="评论量" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            {{scope.row.num_comment}}<cite>|</cite>
            <a @click="m2.modal=true;m2.zid=scope.row.id">管理</a>
          </template>
        </el-table-column>
        <el-table-column prop="jiazan" label="点赞量" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
        <FormItem label="讲师头像" required>
          <UploadOne v-model="detail.img"></UploadOne>
          图片大小：正方形，大小：30KB以内
        </FormItem>
				<FormItem label="标题">
					<Input v-model="detail.title"/>
				</FormItem>
				<FormItem label="内容">
					<Input v-model="detail.content" type="textarea" :autosize="{minRows:5}"/>
				</FormItem>
				<FormItem label="作者">
					<Input v-model="detail.author"/>
				</FormItem>

        <FormItem label="姓名">
          <Input v-model="detail.xm"/>
        </FormItem>
        <FormItem label="公司">
          <Input v-model="detail.gs"/>
        </FormItem>
        <FormItem label="职位">
          <Input v-model="detail.zw"/>
        </FormItem>

        <FormItem label="预览量">
          <Input v-model="detail.show" type="number"/>
        </FormItem>
        <FormItem label="点赞量">
          <Input v-model="detail.jiazan" type="number"/>
        </FormItem>

      </Form>
    </Modal>

    <Drawer title="评论管理" width="800" v-model="m2.modal">
      <ZeComment :zid="m2.zid"></ZeComment>
    </Drawer>

  </div>
</template>

<script>
  import UploadOne from '@/public/upload/UploadOne'
  import ZeComment from './zhunze/ZeComment'
  export default {
    components:{UploadOne,ZeComment},
    data(){
      return{
        baseUrl:'/api/zhunze/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        m2:{ //评论管理
          modal:false,
          zid:0
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Zhunze.vue